import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Sparkles, Gift } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function DailyChallenge() {
  const { refresh } = useAuth();
  const [state, setState] = useState({ challenge: null, claimed: false, eligible: false });
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/daily-challenge").then((r) => setState(r.data));
  useEffect(() => { load(); }, []);

  const claim = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/daily-challenge/claim");
      toast.success(`+${data.reward} chips claimed`);
      await refresh();
      load();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Cannot claim yet");
    } finally { setBusy(false); }
  };

  const c = state.challenge;
  return (
    <div className="space-y-6">
      <div>
        <div className="pill pill-gold inline-flex items-center gap-1"><Sparkles className="w-3.5 h-3.5" /> Daily AI</div>
        <h1 className="font-display text-3xl sm:text-4xl mt-2">Today&apos;s Skill Mission</h1>
      </div>

      {!c && <div className="vexis-card p-8 text-slate-400" data-testid="daily-loading">Curating today&apos;s challenge…</div>}
      {c && (
        <div className="vexis-card p-6 sm:p-10 relative overflow-hidden">
          <div className="absolute -top-16 -right-16 w-72 h-72 rounded-full opacity-30" style={{background: "radial-gradient(closest-side, rgba(226,185,106,0.35), transparent)"}} />
          <h2 className="font-display text-3xl sm:text-5xl leading-tight" data-testid="daily-title">{c.title}</h2>
          <p className="text-slate-300 mt-4 max-w-2xl text-base sm:text-lg" data-testid="daily-description">{c.description}</p>

          <div className="mt-6 flex flex-wrap gap-2 text-xs">
            <span className="pill">Game · <span className="uppercase">{c.game}</span></span>
            <span className="pill">Objective · {c.goal}</span>
            <span className="pill">Difficulty · {c.difficulty}</span>
            <span className="pill pill-gold">Reward · {c.reward} chips</span>
          </div>

          <div className="mt-8 gold-hairline" />
          <div className="mt-6 flex flex-wrap items-center gap-3">
            <Link to={`/play/${c.game}`} className="btn-gold inline-flex items-center gap-2" data-testid="daily-play">Play {c.game}</Link>
            <button onClick={claim} disabled={state.claimed || busy || !state.eligible} className="btn-ghost inline-flex items-center gap-2" data-testid="daily-claim">
              <Gift className="w-4 h-4" /> {state.claimed ? "Reward claimed" : busy ? "Claiming…" : state.eligible ? "Claim reward" : "Win a matching game to unlock"}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
